import IconLightMode from '@mui/icons-material/Brightness7'
import IconDarkMode from '@mui/icons-material/Brightness4'
import { i18n } from 'src/i18n'
import { useAppDispatch, useAppSelector } from 'src/modules/hooks'
import { AppBar, Box, IconButton } from '@mui/material'
import { settingsThunkActions } from 'src/modules/settings/settings_slice'
import settingsSelectors from 'src/modules/settings/settingsSelectors'
import settingsConstants from 'src/modules/settings/settingsConstants'

const styles = {
  appBar: (theme) => ({
    position: 'fixed',
    color: theme.palette.getContrastText(theme.palette.primary.main),

    zIndex: theme.zIndex.drawer + 1,
    height: '55px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '10px',
    paddingRight: '20px',
    boxShadow: 'none',
  }),
  logo: (theme) => ({
    //paddingLeft: theme.spacing(1),
    fontWeight: 500,
    fontSize: '1.5em',
    color: theme.palette.getContrastText(theme.palette.primary.main),
    textDecoration: 'none',
    // backgroundImage: 'url(/images/stringr-map.png)',
    height: '100%',
    width: '332px',
    display: 'flex',
    alignItems: 'center',
  }),
  rightButtons: {
    // For very small screens move the right buttons close to the right edge so that there is more room for the search field.
    //Otherwise the search field and the right buttons overlap on small screens.
    // [theme.breakpoints.up('xs')]: {
    //   marginRight: '-40px',
    // },
    // [theme.breakpoints.up('sm')]: {
    //   marginRight: '0px',
    // },
  },
  toogleDarkModeButton: {
    // [theme.breakpoints.up('xs')]: {
    //   padding: '0px',
    // },
    // [theme.breakpoints.up('md')]: {
    //   padding: '20px',
    // },
  },
}

function Header(props) {
  const dispatch = useAppDispatch()

  const logoUrl = settingsConstants.textLogoWhiteUrl
  const isDarkMode = useAppSelector(settingsSelectors.selectIsDark)

  // const doToggleMenu = () => {
  //   dispatch(layoutSlice.actions.toggleMenu())
  // }
  const doToggleDarkMode = () => {
    const isDark = !isDarkMode
    dispatch(settingsThunkActions.saveIsDark(isDark))
  }

  const iconToggleDarkMode = isDarkMode ? <IconLightMode /> : <IconDarkMode />

  return (
    <AppBar sx={styles.appBar}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* {!props.hideMenuIcon && (
          <IconButton edge="start" onClick={doToggleMenu} color="inherit">
            <MenuIcon />
          </IconButton>
        )} */}
        <Box sx={styles.logo}>
          <a href="/">
            {
              <img
                src={logoUrl}
                alt={i18n('app.title')}
                style={{
                  verticalAlign: 'middle',
                  objectFit: 'contain',
                }}
                width="87"
                height="34"
              />
            }
          </a>
        </Box>
      </div>
      {/* <Box sx={styles.topMenu}> */}
      <Box sx={styles.rightButtons}>
        <IconButton edge="start" onClick={doToggleDarkMode} color="inherit" sx={styles.toogleDarkModeButton}>
          {iconToggleDarkMode}
        </IconButton>
        {/* <UserMenu /> */}
      </Box>
    </AppBar>
  )
}

export default Header
